module.exports = __webpack_public_path__ + "img/Group 897.0034104b.svg";